// extracted by mini-css-extract-plugin
export default {"root":"Icon_root__CV4Wq"};